import { instagram, facebook } from '~/utils/socials.js'

const SITE_URL = `https://${process.env.GATSBY_SITE_URL}`

const TELEPHONE = '+55-48-3113-2022'

const SERVICES = [
  'Assinatura de veículos para pessoas físicas',
  'Assinatura de veículos para empresas',
  'Terceirização e gestão de frotas',
  'Planos personalizados de acordo com prazo e quilometragem',
  'Veículos zero-quilômetro',
  'Opções de veículos blindados',
  'Manutenção e revisões programadas',
  'Seguro, IPVA e documentação incluídos',
  'Assistência 24 horas',
]

export const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'Dimas Sempre',
  url: SITE_URL,
  image: `${SITE_URL}/opengraph.jpg`,
  description:
    'Empresa do Grupo Dimas especializada em veículos por assinatura e terceirização de frotas, oferecendo uma alternativa prática para pessoas e empresas utilizarem carros novos sem as burocracias da compra.',
  disambiguatingDescription:
    'A Dimas Sempre integra o Grupo Dimas e oferece veículos por assinatura com os principais custos reunidos em uma única mensalidade. O serviço permite dirigir um carro novo sem entrada e sem preocupações com seguro, IPVA, documentação, revisões e manutenção, conforme as condições do plano contratado. Também atende empresas que buscam reduzir custos e simplificar a gestão de suas frotas.',
  telephone: TELEPHONE,
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: TELEPHONE,
    hoursAvailable: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '08:00',
      closes: '18:00',
    },
  },
  sameAs: [
    instagram,
    facebook,
    'https://www.linkedin.com/company/dimassempre/',
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    itemListElement: SERVICES.map((name) => ({
      '@type': 'Offer',
      itemOffered: { '@type': 'Service', name },
    })),
  },
  parentOrganization: {
    '@type': 'Organization',
    '@id': 'https://www.dimas.com.br/#organization',
    name: 'Grupo Dimas',
    url: 'https://www.dimas.com.br',
  },
}
